import {computed, inject, Injectable, signal} from '@angular/core';
import {lastValueFrom} from 'rxjs';
import {injectQuery} from '@tanstack/angular-query-experimental';
import {QueryKey} from '../../../../../constants/query-key';
import {
  CustomerProductBillingSummary,
  CustomerProductService,
  InvoiceService,
  InvoicingPreviewLine,
} from '../../../../../../api';

@Injectable()
export class CustomerBillingQueryService {
  private readonly invoiceService = inject(InvoiceService);
  private readonly customerProductService = inject(CustomerProductService);

  customerId = signal<number | null>(null);

  invoicingPreviewQuery = injectQuery(() => ({
    queryKey: [QueryKey.INVOICING_PREVIEW, this.customerId()],
    queryFn: () => lastValueFrom(this.invoiceService.getCustomerInvoicingPreview(this.customerId()!)),
    enabled: this.customerId() !== null,
  }));

  billingsQuery = injectQuery(() => ({
    queryKey: [QueryKey.PRODUCT_CUSTOMER_BILLINGS, this.customerId()],
    queryFn: () => lastValueFrom(this.customerProductService.getCustomerProductBillingsByCustomerId(this.customerId()!)),
    enabled: this.customerId() !== null,
  }));

  previewLines = computed<InvoicingPreviewLine[]>(() => this.invoicingPreviewQuery.data()?.lines ?? []);
  billings = computed<CustomerProductBillingSummary[]>(() => this.billingsQuery.data()?.billings ?? []);
}
